module.exports = __webpack_public_path__ + "static/media/pack-ur-bags-bg.48842219.png";